import type { IBaseControlSetting } from '~/presentation/reports/common/type';
import { EControlType } from '~/presentation/reports/common/type';

import { useControlDataChange } from '~/presentation/reports/common';
import { CheckIcon } from '@shopify/polaris-icons';
import { SelectBase } from '../../SelectBase';
import { cls } from '~/utils';

export interface IControlSelectInline extends IBaseControlSetting<string> {
  type: EControlType.SELECT_INLINE;
}
export const SelectInline: React.FC<IControlSelectInline> = ({
  defaultValue,
  disabled,
  id,
  draggable,
  label,
  uid,
  dependentControls,
  info,
}) => {
  const { emitControlChange } = useControlDataChange();

  if (!uid) return null;

  const isSelected = defaultValue === uid;

  const onDelete = () => {
    if (!dependentControls?.length || !isSelected) return;

    const dependentControl = dependentControls[0];
    emitControlChange({ [id]: dependentControl.value?.[0] });
  };

  return (
    <div
      onClick={() => {
        emitControlChange({ [id]: uid });
      }}
      key={uid}
      className={cls({
        'opacity-50': disabled,
        'cursor-pointer': !disabled,
      })}
    >
      <SelectBase
        label={label}
        icon={isSelected ? CheckIcon : undefined}
        draggable={draggable}
        dependentControls={dependentControls}
        uid={uid}
        info={info}
        id={id}
        type={EControlType.SELECT_BASE}
        labelAlign="space-between"
        onDelete={onDelete}
      />
    </div>
  );
};
